<template>
  <div class="OrderReg">
    <div class="page-title">{{ title }}</div>
    <div>
      <el-form
        ref="form"
        label-width="90px"
        class="form-label-90"
        :model="data"
        :rules="rules"
        inline
      >
        <el-row>
          <el-col :span="6">
            <el-form-item label="거래처" prop="customer_name">
              <ACustomerSelector
                v-model="data.customer_name"
                buyer
                @select="handleSelectCustomer"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="업체담당자" prop="customer_charger">
              <el-input v-model="data.customer_charger" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="담당자" prop="charger">
              <el-input v-model="data.charger" />
            </el-form-item>
          </el-col>
          <el-col :span="4" v-if="data.id">
            <el-form-item label="발주번호" prop="code">
              <el-input v-model="data.code" disabled />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4">
            <el-form-item label="발주일" prop="order_date">
              <ADatePicker v-model="data.order_date" :clearable="false" />
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="입고일" prop="valid_date">
              <ADatePicker v-model="data.valid_date" />
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="매입일" prop="inbound_date">
              <ADatePicker
                v-model="data.inbound_date"
                :disabled="checkStatusFlag"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="도착지" prop="destination ">
              <el-input v-model="data.destination" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="비고" prop="desc">
              <el-input v-model="data.desc" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-tabs type="card" v-model="activeTab" @tab-click="handleTabClick">
        <el-tab-pane label="등록" name="1">
          <ATradeTable
            ref="trade"
            :items="data.details"
            :customer="customer"
            :disabled="disabled"
            disableSizeAmount
            @changedSum="handleChangedSum"
          />
          <div class="row-splitter pb-default">
            <el-button
              type="primary"
              v-shortkey="['f4']"
              :disabled="sum === 1 || isOrder || !has_grant_write"
              :loading="load_button"
              @shortkey.native="handleClickRegister"
              @click="handleClickRegister"
              >{{
                isNew ? $t("button.register") : $t("button.modify")
              }}(F4)</el-button
            >
            <el-button
              :disabled="disabled || !has_grant_write"
              v-show="!isNew"
              @click="handleCopyRegister"
              >복사 등록</el-button
            >
            <el-button :disabled="disabled" @click="handleClickClear"
              >초기화</el-button
            >
            <el-button
              :disabled="disabled"
              @click="handleClickSelectGlassContract"
              >수주 가져오기</el-button
            >
            <el-button :disabled="disabled" @click="handleClickLibrary"
              >라이브러리</el-button
            >
            <el-button
              v-shortkey="['f8']"
              :disabled="disabled"
              @shortkey.native="handleClickSaveTemp"
              @click="handleClickSaveTemp"
              >{{ $t("button.save_temp") }}(F8)</el-button
            >
            <el-button
              type="danger"
              v-show="!isNew"
              :disabled="disabled || isOrder || !has_grant_write"
              :loading="load_button"
              @click="handleClickDelete"
              >{{ $t("button.delete") }}</el-button
            >
            <div v-if="isOrder" class="inline pl-default">
              <el-tag>입고등록</el-tag>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="발주내역" name="2">
          <OrderHistory
            ref="history"
            v-if="!disabled"
            :customer_id="data.customer_id"
            @selected="handelSelected"
          />
        </el-tab-pane>
      </el-tabs>
      <el-dialog
        title="수주 가져오기"
        top="10"
        custom-class="form-dialog"
        destroyOnClose
        :close-on-click-modal="false"
        :visible.sync="dialogVisible"
        :modal="false"
      >
        <GlassContractSelect @selceted="handleContractSelected" />
      </el-dialog>
      <el-dialog
        title="라이브러리"
        top="10"
        custom-class="form-dialog"
        destroyOnClose
        :close-on-click-modal="false"
        :visible.sync="dialog_library_visible"
        :modal="false"
      >
        <LibraryDialog
          v-if="dialog_library_visible"
          :data="library_details"
          type_flag="2"
          :has_grant_write="has_grant_write"
          @completed="handelLibraryCompleted"
          @select="handleSelectLibrary"
        />
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { form_container } from "@/common/mixins/form_container";
import { order_form } from "@/common/mixins/order_form";
import { enter_tab } from "@/common/mixins/enter_tab";
import { authority_level } from "@/common/mixins/authority_level";
import LibraryDialog from "@/spa/Common/LibraryDialog";
import OrderHistory from "./OrderHistory";
import GlassContractSelect from "./GlassContractSelect";

export default {
  name: "OrderReg",
  mixins: [form_container, enter_tab, order_form, authority_level],
  components: { LibraryDialog, OrderHistory, GlassContractSelect },
  data() {
    return {
      title: this.$t("title.order_reg"),
      visibleHistory: false,
      activeTab: "1",
      data: undefined,
      dialogVisible: false,
      dialog_library_visible: false,
      library_details: null,
      load_button: false,
    };
  },
  computed: {
    ...mapGetters(["table_customer", "temp_data"]),
    has_grant_write() {
      return this.isWriteLevel("order_reg");
    },
  },
  created() {
    if (this.temp_data[this.$options.name]) {
      this.data = Object.assign({}, this.temp_data[this.$options.name]);
      this.customer = this.table_customer.find(
        (c) => c.id === this.data.customer_id
      );
    } else {
      this.data = this.initData();
    }
  },
  methods: {
    doRegister() {
      let data = Object.assign({}, this.data);
      data.price = this.sum;
      data.details = this.getDetails();

      let api = this.isNew ? this.api.createOrder : this.api.updateOrder;
      let message = this.isNew
        ? this.$t("message.success_create")
        : this.$t("message.success_update");
      this.load_button = true;
      api(data).then((res) => {
        this.load_button = false;
        this.handleResponse(res, message);
        if (res.error !== this.system.noError) {
          return;
        }
        this.data = res.data;
      });
    },
    doDelete() {
      const data = Object.assign({}, this.data);
      this.load_button = true;
      this.api.deleteOrder(data).then((res) => {
        this.load_button = false;
        this.handleResponse(res, this.$t("message.success_delete"), false);
      });
    },
    async handleClickRegister() {
      if (this.disabled || this.isOrder || !this.has_grant_write) {
        return;
      }
      if(!this.isNew){
        const res = await this.api.selectOrder(this.data.id);
        const data = res.data
        const result = data.details.some(d => d.status_flag !== '0')
        if(result){
          this.util.notify_warning(
            this,
            this.title,
            "입고등록 된 항목이 있습니다. 확인 후 재시도해 주세요."
          );
          return;
        }
      }
      this.$refs.form.validate((valid) => {
        if (!valid) {
          this.util.notify_warning(
            this,
            this.title,
            "필수 입력 항목이 비어있습니다."
          );
          return;
        }
        let details = this.getDetails();
        if (details.length < 1) {
          this.util.notify_warning(this, this.title, "내역을 입력해 주세요.");
          return;
        }
        if (this.invalid_details.length > 0) {
          this.util.notify_warning(
            this,
            this.title,
            this.invalid_details +
              "번째 품명을 올바르게 선택하지 않으셨습니다. 다시 선택하여 주시기 바랍니다."
          );
          return;
        }
        if (this.isNew && this.util.isPastDate(this.data.order_date)) {
          this.util.confirm(
            this,
            this.title,
            "발주일이 오늘보다 늦습니다. 계속 등록하시겠습니까?",
            this.doRegister
          );
          return;
        }
        this.doRegister();
      });
    },
    handleClickEstimation() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        this.openDialog();
      });
    },
    completed(action, message) {
      const options = this.util.get_notify_options("s", this.title, message);
      this.$emit("completed", action, options);
    },
    handleTabClick(tab) {
      if (tab.index !== "1") {
        return;
      }
      this.visibleHistory = true;
      if (!this.$refs.history) {
        return;
      }
      this.$refs.history.loadData();
    },
    handelSelected(data) {
      this.data = data;
      this.sum = this.data.price;
      this.activeTab = "1";
    },
    handleClickDelete() {
      if (this.disabled || this.isOrder || !this.has_grant_write) {
        return;
      }
      this.util.confirm_delete(this, this.title, this.doDelete);
    },
    handleResponse(res, success_message, isMove = true) {
      if (res.error !== this.system.noError) {
        this.util.notify_response_error(this, this.title, res);
        return;
      }
      this.temp_data[this.$options.name] = null;
      this.util.notify_success(this, this.title, success_message);
      if (!isMove) {
        return;
      }
      this.activeTab = "1";
    },
    /** 임시 저장 */
    handleClickSaveTemp() {
      let data = Object.assign({}, this.data);
      data.price = this.sum;
      data.details = this.getDetails();
      this.temp_data[this.$options.name] = data;
    },
    /** 유리 수주 가져오기 */
    handleClickSelectGlassContract() {
      this.dialogVisible = true;
    },
    handleContractSelected(selection) {
      selection.forEach((d) => {
        d.contract_detail_id = d.id;
        d.id = null;
        d.cost = null;
        d.supply_price = null;
        d.tax = null;
        d.price = null;
        d.fix_amount = 0;
        this.data.details.push(d);
      });
      this.dialogVisible = false;
    },
    handleClickLibrary() {
      this.library_details = this.getDetails();
      this.library_details.forEach((item) => {
        if (!item.status_flag) {
          item.status_flag = "0";
        }
      });
      this.dialog_library_visible = true;
    },
    handelLibraryCompleted() {
      this.dialog_library_visible = false;
    },
    handleSelectLibrary(library) {
      library.details.forEach((d) => {
        d.id = 0;
        this.data.details.push(d);
      });
      this.dialog_library_visible = false;
    },
    handleCopyRegister() {
      this.data.id = 0;
      this.data.code = "";
      this.data.details.forEach((item) => {
        item.id = null;
        item.order_id = null;
        item.status_flag = "0";
        item.fix_amount = 0;
      });
    },
  },
};
</script>
